// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ImageZoom: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
            <path
                fill="currentColor"
                d="M19.4218761,0.0723433495 C19.3046886,0.025023222 19.1835946,0 19.0625006,0 L13.4726566,0 C12.9218751,0 12.5000006,0.419921875 12.5000006,0.9375 C12.5000006,1.45507812 12.9199225,1.875 13.4375006,1.875 L16.7992193,1.875 L11.5257818,7.1484375 C11.1595708,7.51464844 11.1595708,8.1078124 11.5257818,8.47421885 C11.8919927,8.84062529 12.4851567,8.84042978 12.8515631,8.47421885 L18.1250006,3.20078135 L18.1250006,6.5625 C18.1250006,7.08203077 18.5468751,7.5 19.0625006,7.5 C19.5781261,7.5 20.0000006,7.07812548 20.0000006,6.52734399 L20.0000006,0.9375 C20.0000006,0.815117359 19.9749774,0.693359375 19.9275392,0.578906536 C19.8320323,0.349882841 19.6484381,0.167382956 19.4218761,0.0723433495 Z M0.579296947,19.9257815 C0.693750381,19.9765623 0.815625191,20 0.9375,20 L6.52734399,20 C7.07812488,20 7.5,19.5820308 7.5,19.0625 C7.5,18.5429692 7.08203137,18.125 6.5625,18.125 L3.20078135,18.125 L8.47421885,12.8515625 C8.84042978,12.4853516 8.84042978,11.8921876 8.47421885,11.5257812 C8.10800791,11.1593747 7.51484394,11.1595702 7.1484375,11.5257812 L1.875,16.8007815 L1.875,13.4375 C1.875,12.9218745 1.45507812,12.5 0.9375,12.5 C0.419921875,12.5 0,12.9218745 0,13.4375 L0,19.0625 C0,19.1848826 0.025023222,19.3066406 0.0724607706,19.4210935 C0.16753912,19.6484375 0.350195169,19.8320317 0.579296947,19.9257815 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(ImageZoom);
